module.exports = __webpack_public_path__ + "static/img/n_4_1.79bcd86c.png";